<template>
    <div id="survey-container" class="footer d-flex justify-content-end shadow-none bg-transparent pe-none">
        <div id="survey" class="shadow-lg d-inline-block pe-auto" :class="!isGivingFeedback ? 'clickable' : ''" v-if="!isSurveyDismissed" @click="isGivingFeedback = true">

            <div id="feedback-btn" class="me-4 fw-bold" v-if="!isGivingFeedback">
                Give Feedback
            </div>

            <div id="iframe-container" v-if="isGivingFeedback">
                <iframe
                    id="questions"
                    title="Survey"
                    :src="surveyUrl">
                </iframe>
            </div>

            <div id="dismiss-survey" class="position-absolute top-0 m-2" @click.prevent="dismissSurvey()">
                <font-awesome-icon  icon="x" size="lg"></font-awesome-icon>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue'
    import axios from 'axios'
    import * as lst from '@/components/localStorage.js'

    const isSurveyDismissed = ref(true)
    const surveyUrl = ref('')
    const surveyExpiry = ref(0)

    const isGivingFeedback = ref(false)

    const closedPrefix = 'closedNotice' // prefix prevents clearing on logout. see Logout.vue

    let surveyKey;

    onMounted(async () => {
        const bannerResponse = await axios.get('/timetable/banners/category/44')
        const banner = bannerResponse.data.banners[0]

        if (!banner) {
            isSurveyDismissed.value = true
            return
        }

        surveyUrl.value = banner.content
        surveyExpiry.value = banner.expiryTime * 1000

        surveyKey = closedPrefix + banner.bannerId

        if (surveyExpiry.value < Date.now()) {
            isSurveyDismissed.value = true
            return
        }

        const stored = lst.getValue(surveyKey)

        isSurveyDismissed.value = !!stored && Date.now() < stored
    })

    function dismissSurvey() {
        lst.setValue(surveyKey, surveyExpiry.value)
        isSurveyDismissed.value = true
    }
</script>

<style>
    #survey-container {
        bottom: 64px;
    }

    #survey {
        border-width: 4px;
        border-color: var(--uog-dark-blue);
        border-style: solid;
        border-radius: 20px;
        padding: 6px 8px;
        background-color: white;
        animation-delay: 1s;
        animation-name: animate-fade;
        animation-fill-mode: backwards;
        animation-duration: 300ms;
        z-index: 1002;
    }

    #feedback-btn {
        font-size: 1rem;
        color: var(--uog-dark-blue);
    }

    @keyframes animate-fade {
        0% {
            pointer-events: none;
            opacity: 0%;
        }
        100% {
            pointer-events: all;
            opacity: 100%;
        }
    }

    .clickable:hover {
        cursor: pointer;
    }

    #dismiss-survey {
        color: var(--uog-dark-blue);
        right: 5px;
    }

    #dismiss-survey:hover {
        cursor: pointer;
    }

    #iframe-container {
        position: relative;
        top: 0;
        left: 0;
    }

    #questions {
        height: 454px;
        width: 300px;
    }
</style>
